import { useCallback } from "react";

export default function DeleteActions({
  canDeleteAdminUser,
  setAdminError,
  texts,
  setDeleteUserModalUser,
  setDeleteUserConfirmText,
  setDeleteUserNotice,
  deleteUserSaving,
  deleteUserModalUser,
  deleteUserConfirmText,
  setDeleteUserSaving,
  adminFetch,
  apiBaseUrl,
  readApiJson,
  fetchAdminData,
  setAdminToast
}) {
  const openDeleteUserModal = useCallback((userItem) => {
    if (!canDeleteAdminUser(userItem)) {
      setAdminError(texts.userManagementRestrictedHint || "You can only manage users with a lower role than your own.");
      return;
    }

    setDeleteUserModalUser(userItem);
    setDeleteUserConfirmText("");
    setDeleteUserNotice("");
  }, [
    canDeleteAdminUser,
    setAdminError,
    setDeleteUserConfirmText,
    setDeleteUserModalUser,
    setDeleteUserNotice,
    texts.userManagementRestrictedHint
  ]);

  const closeDeleteUserModal = useCallback(() => {
    if (deleteUserSaving) {
      return;
    }
    setDeleteUserModalUser(null);
    setDeleteUserConfirmText("");
    setDeleteUserNotice("");
  }, [deleteUserSaving, setDeleteUserConfirmText, setDeleteUserModalUser, setDeleteUserNotice]);

  const submitDeleteUser = useCallback(async (event) => {
    event.preventDefault();

    if (!deleteUserModalUser?.id) {
      setDeleteUserNotice("User context is missing.");
      return;
    }

    if (String(deleteUserConfirmText || "").trim().toUpperCase() !== "DELETE") {
      setDeleteUserNotice("Please type DELETE to confirm.");
      return;
    }

    setDeleteUserSaving(true);
    setDeleteUserNotice("");

    try {
      const response = await adminFetch(`${apiBaseUrl}/admin/users/${deleteUserModalUser.id}`, {
        method: "DELETE"
      });

      const data = await readApiJson(response);
      if (!response.ok) {
        throw new Error(data.message || "Delete user failed");
      }

      await fetchAdminData();
      setAdminToast(texts.userDeleted || texts.remove);
      closeDeleteUserModal();
    } catch (err) {
      if (err.message !== "Session expired") {
        setDeleteUserNotice(err.message || "Delete user failed");
      }
    } finally {
      setDeleteUserSaving(false);
    }
  }, [
    adminFetch,
    apiBaseUrl,
    closeDeleteUserModal,
    deleteUserConfirmText,
    deleteUserModalUser,
    fetchAdminData,
    readApiJson,
    setAdminToast,
    setDeleteUserNotice,
    setDeleteUserSaving,
    texts.remove,
    texts.userDeleted
  ]);

  return {
    openDeleteUserModal,
    closeDeleteUserModal,
    submitDeleteUser
  };
}